import apiService from "service/api";
import { IAddUserForm } from "types";

export const getAllClients = async (params: {
  hfId: number;
  page: number;
  size: number;
  search?: string;
}) => {
  const { hfId, page, size, search } = params;

  let url = `/healthfacilities/${hfId}/enduser/?page=${page}&size=${size}&search=${search}`;

  const method = "get";
  return apiService(url, method, null, true, {});
};

export const createClient = async (
  hfId: number,
  formData: Record<string, any>
) => {
  const url = `/healthfacilities/${hfId}/branch/add-enduser/`;

  return apiService(url, "POST", formData, true);
};

export const deleteClient = async (hfId: number, clientId: number) => {
  const url = `/healthfacilities/${hfId}/enduser/${clientId}/`;

  return apiService(url, "DELETE", null, true);
};
